/**  Combine classnames */
export function cx(...args: string[]): string {
  return args.join(' ');
}
